import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import Checkbox from 'material-ui/Checkbox';
import muiThemeable from 'material-ui/styles/muiThemeable';
import compose from 'recompose/compose';

import FieldTitle from 'util/FieldTitle';

const getStyles = (muiTheme) => {
  const {
    baseTheme,
    textField: {
      floatingLabelColor,
      backgroundColor,
    },
  } = muiTheme;

  return {
    labelContainer: {
      fontSize: 16,
      lineHeight: '24px',
      display: 'inline-block',
      position: 'relative',
      backgroundColor,
      fontFamily: baseTheme.fontFamily,
      cursor: 'auto',
      marginTop: 14,
    },
    label: {
      color: floatingLabelColor,
      lineHeight: '22px',
      zIndex: 1,
      transform: 'scale(0.75)',
      transformOrigin: 'left top',
      pointerEvents: 'none',
      userSelect: 'none',
    },
  };
};

/**
 * An Input component for a checkbox group, using an array of objects for the options
 *
 * Choices are collected dynamically from server reply.
 *
 * The expected input must be an array of identifiers (e.g. [12, 31]) which correspond to
 * the 'optionValue' of 'choices' attribute objects.
 *
 * By default, the options are built from:
 *  - the 'id' property as the option value,
 *  - the 'name' property an the option text
 */
export class MultipleChoicesFromDataInputComponent extends Component {
  handleCheck = (event, isChecked) => {
    const { input: { value, onChange } } = this.props;

    if (isChecked) {
      onChange([...value, ...[event.target.value]]);
    } else {
      onChange(value.filter(v => (v !== event.target.value)));
    }
  };

  renderCheckbox = (choice) => {
    const {
      input: { value },
      optionText,
      optionValue,
      options,
    } = this.props;
    const choiceName = React.isValidElement(optionText) ? // eslint-disable-line no-nested-ternary
      React.cloneElement(optionText, { record: choice }) :
      (typeof optionText === 'function' ?
          optionText(choice) :
          choice[optionText]
      );
    return (
      <Checkbox
        key={choice[optionValue]}
        checked={value ? value.find(v => (v === choice[optionValue])) !== undefined : false}
        onCheck={this.handleCheck}
        value={choice[optionValue]}
        label={choiceName}
        {...options}
      />
    );
  }

  render() {
    const { isRequired, label, muiTheme, resource, choiceSource, record, source } = this.props;
    const styles = getStyles(muiTheme);
    const { prepareStyles } = muiTheme;
    const choices = get(record, choiceSource);
    return (
      <div>
        <div style={prepareStyles(styles.labelContainer)}>
          <div style={prepareStyles(styles.label)}>
            <FieldTitle label={label} source={source} resource={resource} isRequired={isRequired}/>
          </div>
        </div>
        {choices && choices.map(this.renderCheckbox)}
      </div>
    );
  }
}

MultipleChoicesFromDataInputComponent.propTypes = {
  addField: PropTypes.bool.isRequired,
  choices: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  source: PropTypes.string,
  options: PropTypes.object,
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
  }),
  isRequired: PropTypes.bool,
  optionText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]).isRequired,
  optionValue: PropTypes.string.isRequired,
  resource: PropTypes.string,
  muiTheme: PropTypes.object.isRequired,
  record: PropTypes.object,
  choiceSource: PropTypes.string.isRequired,
};

MultipleChoicesFromDataInputComponent.defaultProps = {
  addField: true,
  choices: [],
  options: {},
  optionText: 'name',
  optionValue: 'id',
};

const enhance = compose(muiThemeable());

const MultipleChoicesFromDataInput = enhance(MultipleChoicesFromDataInputComponent);

MultipleChoicesFromDataInput.propTypes = {
  addField: PropTypes.bool.isRequired,
};

MultipleChoicesFromDataInput.defaultProps = {
  addField: true,
};

export default MultipleChoicesFromDataInput;



// WEBPACK FOOTER //
// ./src/components/input/MultipleChoicesFromData.js